import { BoxProps, Skeleton, Theme, Typography } from '@mui/material';
import { SxProps } from '@mui/system';
import { FC } from 'react';
import { StyledContainer } from './CategoryRowContainer.styles';

export type CategoryRowContainerProps =
  | ({
      sx?: SxProps<Theme>;
      loadingPlaceholder?: never;
    } & BoxProps)
  | {
      sx?: SxProps<Theme>;
      loadingPlaceholder: true;
    };

export const CategoryRowContainer: FC<CategoryRowContainerProps> = (props: CategoryRowContainerProps) => {
  if (props.loadingPlaceholder) {
    return (
      <Skeleton variant='rectangular' width='100%' sx={props.sx}>
        <StyledContainer>
          <Typography variant='paragraphBold'>Uncategorized (0)</Typography>
        </StyledContainer>
      </Skeleton>
    );
  }

  return <StyledContainer {...props} />;
};
